'use strict';var trunc=require('../internals/math-trunc');// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports=function(argument){var number=+argument;// eslint-disable-next-line no-self-compare -- NaN check
return number!==number||number===0?0:trunc(number);};